<template>
  <div class="operate-outer" v-if="visible && +homeInfo.activityState === 2">
    <div class="operate-inner">
      <div class="operate-btn" @click="openShare">立即邀请</div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import visibleObserver from 'dom-visible-observer';

export default {
  data() {
    return {
      visible: false
    };
  },
  computed: {
    ...mapState({
      homeInfo: state => state.share.homeInfo
    })
  },
  mounted() {
    this.listeningScroll();
  },
  methods: {
    async openShare() {
      this.uploadData(this.$teleCodes.clickInvite, 'event');
      // 根据是否存在邀请人信息判断是否登录
      if (!this.homeInfo.inviterUserId) {
        await this.adapt.reLogin();
        return;
      }
      this.$bus.$emit('openShareDialog');
    },
    // 监听滚动
    listeningScroll() {
      try {
        const el = document.getElementById('first-screen-btn');
        visibleObserver({
          el,
          show: () => { this.visible = false; },
          hide: () => { this.visible = true; }
        });
      } catch (err) {
        console.error('visibleObserver error', err);
      }
    }
  }
};
</script>

<style scoped lang="less">
.operate-outer {
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .operate-inner {
    padding: 8px 16px;
    box-sizing: border-box;
    width: 100%;
    text-align: center;
    display: flex;

    .operate-btn {
      height: 40px;
      background: #F65425;
      border-radius: 20px;
      color: #fff;
      line-height: 40px;
      font-size: 16px;
      width: 0;
      flex-grow: 1;
    }
  }
}

@supports (bottom: env(safe-area-inset-bottom)) {
  .operate-outer {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}

</style>
